<script setup>
const props = defineProps({
  data: {
    type: Object,
    default: null,
  },
  gap: {
    type: String,
    default: "3",
  },
  edgeNegativeMargin: {
    type: String,
    default: "0",
  },
  itemSize: {
    type: String,
    default: "",
  },
})
const { isMobile } = useDevice()
const reactiveData = toRef(props, "data")
const hideScrollBar = ref(false)
onMounted(() => {
  hideScrollBar.value = isMobile
})
</script>

<template>
  <div
    class="horizontal-scroll-feature"
    :class="`-mx-${props.edgeNegativeMargin}`"
  >
    <div
      class="scroll flex align-items-stretch"
      :class="[{ hideScrollBar: hideScrollBar }, `gap-${props.gap}`]"
    >
      <slot name="default" v-if="reactiveData" />
      <slot v-else name="skeleton">
        <div class="flex w-full">
          <div v-for="i in 5" class="item" :key="`${i}-skeleton`">
            <Skeleton
              class="flex-none btn"
              height="33.16px"
              width="120px"
              borderRadius="20px"
            />
          </div>
        </div>
      </slot>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.horizontal-scroll-feature {
  background: transparent;
  position: relative;
  .scroll {
    padding: 6px $padding 16px 0;
    overflow-y: hidden;
    overflow-x: auto;
    scroll-behavior: smooth;
    -webkit-mask-image: linear-gradient(
      to right,
      rgba(0, 0, 0, 0) 0%,
      rgba(0, 0, 0, 1) 6%,
      rgba(0, 0, 0, 1) 94%,
      rgba(0, 0, 0, 0) 100%
    );
    mask-image: linear-gradient(
      to right,
      rgba(0, 0, 0, 0) 0%,
      rgba(0, 0, 0, 1) 6%,
      rgba(0, 0, 0, 1) 94%,
      rgba(0, 0, 0, 0) 100%
    );
    &.hideScrollBar {
      padding-bottom: 0;
      &::-webkit-scrollbar {
        display: none;
      }
    }
  }
}
</style>
<style lang="scss">
.horizontal-scroll-feature {
  .scroll {
    .item {
      min-width: v-bind(itemSize);
      max-width: v-bind(itemSize);
      &:first-child {
        margin-left: 3rem;
        @include media("<md") {
          margin-left: 1.5rem;
        }
      }
      &:not(.large-card):last-child {
        @include media("<md") {
          margin-right: 1.5rem;
        }
      }
      &.large-card:last-child {
        @include media("<md") {
          margin-right: 1.5rem;
        }
      }
      &.btn:first-child,
      .btn {
        //margin-left: 1.5rem;
      }
    }
  }
}
</style>
